import React from "react";
import HeroVideo from "../components/gallery/HeroVideo";
import GallerySection from "../components/gallery/GallerySection";
import AboutSection from "../components/gallery/AboutSection";
import WorkSection from "../components/gallery/WorkSection";
import PricingSection from "../components/gallery/PricingSection";
import StudioSection from "../components/gallery/StudioSection";
import SuccessStoriesSection from "../components/gallery/SuccessStoriesSection";
import DocumentarySection from "../components/gallery/DocumentarySection";
import Posters from "../components/gallery/Posters";
import PeaksImageBelt from "../components/gallery/PeaksImageBelt";

const Gallery = () => {
  return (
    <section className="relative w-full min-h-screen text-white">
        <HeroVideo />
        <StudioSection />
        <GallerySection />
        {/* <AboutSection /> */}
        <WorkSection />
        <PeaksImageBelt />
        {/* <PricingSection /> */}
        <DocumentarySection />
        <Posters />
        <SuccessStoriesSection/>
    </section>
  );
};

export default Gallery;
